import Company from './company';
import Collection from "../../data-structures/collection";
import {CompanyRole} from "../../gd/const/company-role";


export default class Companies extends Collection<Company> {

    constructor(companies:Company[]=[]) {
        super(companies)
    }

    get(id: ID):Company {

        const company = this.byId[id]

        if (company) {
            return company
        }

        if (!company) {
            console.warn("#ddjh39834762 no company id=",id," found")
        }

        return gd.company

        // return this.byId[id]
    }


    sort() {
        this.models = _.sortBy(this.models, 'name')
    }

    resetFromJson(data:JSONArray) {

        const models : Company[] = []
        _.map(data, (companyData:JSONObject)=>{
            models.push(new Company(companyData))
        })
        return this.reset(models)

    }

    // defautl sort by ?
    // comparator: function(m) {
    //     return m.name;
    //     // return -gd.session.recent.organizations.getCounter(m.id);
    // },

    // static initFromJson(data:any[]) {
    //
    //     const models : Expense [] = []
    //     _.map(data, (expenseData:any)=>{
    //         models.push(new Expense(expenseData))
    //     })
    //
    //     return new Companies(models)
    // }

    filterByRoles(arrRoles:CompanyRole[]) {
        const models = _.filter(this.models, (company) => {
            return arrRoles.indexOf(company.role)>-1
        })

        return new Companies(models)
    }

    filterByLevel(companyRole:CompanyRole) {
        const models = _.filter(this.models, (company) => {
            return company.role===companyRole
        })

        return new Companies(models)
    }

    exportToOptions() {

        return  _.orderBy(
            _.map(this.models, function(m){

                return {
                    'value'     : m.id,
                    'label'     : m.name,
                    // @ts-ignore
                    'icon'      : m.iconNormal,
                    'iconObj'   : m
                }
            }),
            [i=>i.label.toLowerCase()],
            ['asc']
        );

    }

    // not in use
    // exportList: function () {
    //     console.error("GD warning: MyCompanies exportList function is deprecated");
    //     return this.map(function(company){
    //         return {
    //             'label': company.name,
    //             'value': company.id,
    //             'icon': company.iconNormal
    //         }
    //     })
    // },

    // getPositionById(companyId) {
    //     return this.indexOf(this.get(companyId));
    // },

    // exportMenu: function () {
    //     let menu = this.map(function (company) {
    //         return company.exportMenu()
    //     });
    //
    //     return menu;
    // },


}



